module.exports = __webpack_public_path__ + "static/media/deepen.4aea90f5.svg";